$(function() {
  var brand_data = JSON.parse($('#brand-data').text());
  brand_data.sort(function(a, b) {
    if (a.name_en < b.name_en) return -1;
    if (a.name_en > b.name_en) return 1;
    return 0;
  })
  var current_group = '';
  var output = '';
  brand_data.forEach(function(item, index) {
    if (item.group !== current_group) {
      current_group = item.group;
      if (index !== 0) {
        output += '</div>';
        output += '</div>';
      }
      output += '<div id="brand-'+current_group+'" class="brand-group">' + current_group;
      output += '<div class="brand-list">';
    }
    output += '<div class="brand-item">';
    output += '<a href="'+item.url+'">';
    output += '<div class="brand-thumbnail">';
    output += '<img src="'+item.logo+'"/>';
    output += '</div>';
    output += '<p class="brand-name-en">' + item.name_en + '</p>';
    output += '<p class="brand-name-jp">' + item.name_jp + '</p>';
    output += '</a>';
    output += '</div>';
    if (index === brand_data.length - 1) {
      output += '</div>';
      output += '</div>';
    }
  })
  $('#brand-wrapper').html(output);
})